module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/user-page/user-page.component.html
// module id = ../../../../../src/app/user-page/user-page.component.html
// module chunks = main